import { Laptop } from 'lucide-react';
import { useState } from 'react';
import { apiFileUrl } from '../lib/api';
import { blobToDataUrl, resizeImage } from '../lib/images';
import { cn } from './ui';

/**
 * A device model's picture, fitted inside a white box, or a device outline when there's no picture (or it won't load).
 * `url` is an API address from the server, or a local preview.
 */
export function ModelImage({ url, alt = '', className }: { url: string | null | undefined; alt?: string; className?: string }) {
  const src = url ? (url.startsWith('/api/') ? apiFileUrl(url) : url) : null;
  const [failed, setFailed] = useState<string | null>(null);
  return (
    <div className={cn('flex shrink-0 items-center justify-center overflow-hidden rounded-lg border border-slate-200 bg-white', className)}>
      {src && failed !== src ? (
        <img src={src} alt={alt} loading="lazy" className="size-full object-contain p-1" onError={() => setFailed(src)} />
      ) : (
        <Laptop className="size-1/2 text-slate-300" aria-hidden />
      )}
    </div>
  );
}

/** A picture file made ready to upload as a model's picture: at most 800 pixels on its longest side and 1 MB. */
export async function prepareModelImage(file: File): Promise<string> {
  const { blob } = await resizeImage(file, { maxSide: 800, maxBytes: 1024 * 1024 });
  return blobToDataUrl(blob);
}
